import { APIClient } from "./_api";

export function getResume(data) {
  return APIClient.post(`listUsers`, data);
}
